import { render, staticRenderFns } from "./InputNumber.vue?vue&type=template&id=1041caf0&"
import script from "./InputNumber.ts?vue&type=script&lang=ts&"
export * from "./InputNumber.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports